import { forwardRef } from 'react';

import { Typography } from '..';

import type { TInputProps } from './input.interface';

import './input.scss';

export const Input = forwardRef<HTMLInputElement, TInputProps>(
  (
    {
      label,
      name,
      error,
      disabled = false,
      color = 'default',
      type = 'text',
      endIcon,
      autocomplete = 'off',
      size = 'medium',
      className,
      ...props
    }: TInputProps,
    forwardRef
  ) => {
    let inputClass = '';
    if (disabled) {
      inputClass = 'disabled co-bg-gray-xlight co-border-disabled-main';
    } else if (error) {
      inputClass = 'co-border-error-main co-bg-common-white';
    } else {
      if (color === 'success') {
        inputClass = 'co-border-success-main';
      } else {
        inputClass = 'co-border-common-default';
      }
    }

    function createSize(): string {
      if (size === 'large') {
        return 'co-h-56px';
      }
      if (size === 'medium') {
        return 'co-h-48px';
      }
      return 'co-h-40px';
    }
    return (
      <div className="co-flex co-input-item co-flex-wrap co-gap-8px">
        <label
          className={`
                        co-flex-1
                        co-relative
                        co-m-0
                        co-pl-0
                        co-label-${size}
                    `}
          htmlFor={name}
        >
          <input
            autoComplete={autocomplete}
            disabled={disabled}
            className={`
                        ${inputClass}
                        co-input-text-${size}
                        co-px-16px
                        co-w-full
                        ${createSize()}
                        co-border-1
                        co-rounded-md
                        co-font-normal
                        ${className}
                    `}
            type={type}
            name={name}
            id={name}
            placeholder={name}
            ref={forwardRef}
            {...props}
          />
          <span
            className={`
                        co-text-common-default
                        co-px-8px
                        co-rounded-md
                        ${disabled ? 'co-bg-transparent' : 'co-bg-common-white'}
                        co-absolute
                        co-left-8px
                    `}
          >
            <Typography size="body1">{label}</Typography>
          </span>
          {endIcon && (
            <div
              className={`
                            ${createSize()}
                            co-flex
                            co-justify-center
                            co-items-center
                            co-h-auto
                            co-absolute
                            co-top-0
                            co-right-0
                            co-bg-transparent`}
            >
              {endIcon}
            </div>
          )}
        </label>
        {error && (
          <div className="co-w-full">
            {typeof error === 'string' ? (
              <Typography color="error">{error}</Typography>
            ) : (
              error
            )}
          </div>
        )}
      </div>
    );
  }
);
